module.exports = __webpack_public_path__ + "static/media/jex.ac2f8178.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jex.webp
// module id = 327
// module chunks = 0